import { backboneViewProperties } from "./../../../decorators/backbone-properties";

const template = require<string>("./legislation-overview.html");
@backboneViewProperties({
    template
})
export class LegislationOverviewTabView extends Marionette.ItemView<any> {

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/legislation-overview.ts